"use client";
import { Tabs as TabsParent } from "./tabs.js";
import { TabsContent } from "./tabsContent.js";
import { TabsList } from "./tabsList.js";
import { TabsTrigger } from "./tabsTrigger.js";
const Tabs = Object.assign(TabsParent, {
    List: TabsList,
    Tab: TabsTrigger,
    Panel: TabsContent,
});
Tabs.Tab.displayName = "Tabs.Tab";
Tabs.List.displayName = "Tabs.List";
Tabs.Panel.displayName = "Tabs.Panel";
export { Tabs };
//# sourceMappingURL=index.js.map